import _ from 'lodash';
import MarkdownIt from 'markdown-it';
import mark from 'markdown-it-mark';
import subscript from 'markdown-it-sub';
import superscript from 'markdown-it-sup';

import { API_URL } from
  'assets/js/api/environment';

export default {
  methods: {
    initMd() {
      this.md = new MarkdownIt()
        .use(mark)
        .use(subscript)
        .use(superscript);

      const toDisable = [];
      if (!this.image) {
        toDisable.push('image');
      }
      this.md.disable(toDisable);

      this.md.set({
        html: this.html,
        xhtmlOut: this.xhtmlOut,
        breaks: this.breaks,
        linkify: this.linkify,
        typographer: this.typographer,
        langPrefix: this.langPrefix,
        quotes: this.quotes,
        image: true,
      });

      const defaultImageRenderer = this.md.renderer.rules.image ||
          function defLinkRenderer(tokens, idx, options, env, self) {
            return self.renderToken(tokens, idx, options);
          };
      this.md.renderer.rules.image = (tokens, idx, options, env, self) => {
        const token = tokens[idx];
        const aIndex = token.attrIndex('src');
        const url = token.attrs[aIndex][1];

        // Only allow images we approve ov.
        if (url.startsWith(API_URL)) {
          return defaultImageRenderer(tokens, idx, options, env, self);
        }
        return 'Only uploaded images can be displayed.';
      };

      this.md.renderer.rules.table_open = () =>
        `<table class="${this.tableClass}">\n`;
      const defaultLinkRenderer = this.md.renderer.rules.link_open ||
          function defLinkRenderer(tokens, idx, options, env, self) {
            return self.renderToken(tokens, idx, options);
          };
      this.md.renderer.rules.link_open = (tokens, idx, options, env, self) => {
        const newTokens = tokens;
        if (this.anchorAttributes) {
          Object.keys(this.anchorAttributes).map((attribute) => {
            const aIndex = tokens[idx].attrIndex(attribute);
            const value = this.anchorAttributes[attribute];
            if (aIndex < 0) {
              newTokens[idx].attrPush([attribute, value]); // add new attribute
            } else {
              newTokens[idx].attrs[aIndex][1] = value;
            }
            return false;
          });
        }
        return defaultLinkRenderer(newTokens, idx, options, env, self);
      };
    },

    renderMDStringToHTML(str, show) {
      // Alternative newline ($NEWLINE) for the sake of script convenience.
      const sourceData = _.replace(str, /\$NEWLINE/g, '\n');
      const outHtml = show ?
        this.md.render(
          this.prerender(sourceData),
        ) : '';
      return this.postrender(outHtml);
    },
  },

  props: {
    postrender: {
      type: Function,
      default: (htmlData) => htmlData,
    },
    prerender: {
      type: Function,
      default: (sourceData) => sourceData,
    },
  },
};
